import { Component, OnInit } from '@angular/core';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-request-payment',
  templateUrl: './request-payment.component.html',
  styleUrls: ['./request-payment.component.scss']
})
export class RequestPaymentComponent implements OnInit {
  static route = 'payment-request';

  locale: any = {};

  paymentUrl: string = null;

  constructor(
    private questionnaireService: QuestionnaireService,
    private footer: Footer,
    private localisation: LocalisationService,
    private spinner: LoadingProvider
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('RequestPaymentComponent');

    this.questionnaireService.requestPaymentGateway(true);
    this.questionnaireService.paymentUrl.subscribe(paymentUrl => {
      // Payment URL loaded setup footer
      this.paymentUrl = paymentUrl;
      this.footer.update({
        title: this.locale.footerText,
        action: this.paymentUrl,
        externalLink: true
      });
    });

    // hide the spinner in case the referring page turned it on
    this.spinner.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/request-payment/request-payment.component.ts